module.exports = __webpack_public_path__ + "media/images/testimonial2-69b24ae748a53180c9389ffcf858777a.png";